import { createFileRoute } from "@tanstack/react-router";
import TransactionReportDetailPage from "@/app/(authenticated)/$merchantId/transactions/$tab/$id/_components/transaction-report-detail-page.tsx";

export const Route = createFileRoute(
  "/(authenticated)/$merchantId/transactions/$tab/$id/"
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id, tab } = Route.useParams();
  return <TransactionReportDetailPage tab={tab} id={id} />;
}
